import { render, staticRenderFns } from "./ApprovalCategory.vue?vue&type=template&id=8bf0fd58&scoped=true"
import script from "./ApprovalCategory.vue?vue&type=script&lang=js"
export * from "./ApprovalCategory.vue?vue&type=script&lang=js"
import style0 from "./ApprovalCategory.vue?vue&type=style&index=0&id=8bf0fd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf0fd58",
  null
  
)

export default component.exports